import React from "react";
import videoc from "../../assets/video/tv-box.mp4";
import fondobanner from "../../assets/image/stella/reventa_fondo.jpg";
import imagen from "../../assets/image/stella/installsmartv1.png";

function Tutorial({data}) {

    return (
        <>
            <section className="relative bg-black mb-40">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 100" preserveAspectRatio="none"
                     className="absolute bottom-0 left-0 w-full h-[162px] translate-y-full">
                    <path d="M761.9,44.1L643.1,27.2L333.8,98L0,3.8V0l1000,0v3.9"></path>
                </svg>
                <div className="container px-5 py-10 md:pt-20 md:pb-0">
                    <div className="text-center mb-10"><h6 className="uppercase text-primari">Instalación</h6>
                        <h2 className="mt-3 uppercase text-[26px] md:text-[30px] leading-[1.1em] font-bold">
                        Cómo instalar Stella TV en TV Box Android
                        </h2>
                        <p className="mt-3 max-w-2xl mx-auto text-white">
                            <span className="text-[#ff6600] font-bold">Método1:</span> Usaremos una aplicación llamada
                            <span className="text-[#ff6600] font-bold"> Downloader</span> para descargar Stella TV muy rápido y fácil.

                        </p></div>
                    <div className="grid md:grid-cols-2 gap-6 mt-10 md:p-10">
                        <div className="intersect:animate-in slide-in-from-top intersect-once duration-1250">
                            <div><h4
                                className="relative z-1 p-2.5  md:px-[25px] md:py-5 mb-0 md:w-max font-bold uppercase border border-bottom-0 border-white text-[#F9AA02] bg-black">PASO
                                1</h4>
                                <div className="relative md:-top-[2px] p-2.5 md:p-5 leading-relaxed border text-white">Desde nuestra TV Box debemos ir a la tienda de aplicaciones
                                    <span className="text-[#ff6600]">Play Store</span>buscaremos la app
                                    <span className="text-[#ff6600]">Downloader</span>, para descargarla e instalarla. Es compatible con todas las TV Box.
                                </div>
                            </div>
                        </div>
                        <div className="intersect:animate-in slide-in-from-top intersect-once duration-1250">
                            <div><h4
                                className="relative z-1 p-2.5 md:px-[25px] md:py-5 md:w-max mb-0 font-bold uppercase border border-bottom-0 border-white text-[#F9AA02] bg-black">PASO
                                2</h4>
                                <div className="relative md:-top-[2px] p-2.5 md:p-5 leading-relaxed border text-white">Tenemos que
                                    abrir la app <span className="text-[#ff6600]">downloader</span>, en su pagina
                                    principal escribiremos el link: <span className="text-[#ff6600] font-bold">{data.link}</span> y luego presionamos
                                    el botón «<span className="text-[#ff6600]">GO</span>«, esperamos que descargue y
                                    hacemos clic en <span className="text-[#ff6600]">«Instalar»</span> y listo.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="mt-8 mx-auto text-center"><p className="leading-relaxed text-white"><span
                        className="text-[#ff6600] font-bold">NOTA:</span> Tener en cuenta que se debe tener activados
                        los permisos de «<span className="underline">fuentes desconocidas</span>» para instalar la apk.
                    </p></div>
                    <div className="mt-10 flex justify-center">
                        <div className="w-full md:w-[60%]"><h4
                            className="text-2xl font-semibold uppercase text-center mb-5">VIDEO TUTORIAL - GUÍA</h4>
                            <video className="w-full rounded-[10px] h-[400px]"
                                   src={videoc}
                                   controls
                                   controlsList="nodownload">Video tutorial de instalación de Stella TV
                            </video>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Tutorial;
